module.exports = __webpack_public_path__ + "media/images/background-indicator-7f1a941244953ee7722d730ef7f65b35.png";